import type { FC } from 'react';
import type { Match, WrestlerInMatch } from '../../../types';
import { AvatarOpponentBoxAvatar, BeltImg, BoxWinnerGeneric, CenterInfoFight } from './GenericComponentCssMatchCard';

interface CenterInfoFightComponentRenderProps {
    nameMatch: string;
    matchInfo: Match;
    className?: string;
}

const CenterInfoFightComponentRender: FC<CenterInfoFightComponentRenderProps> = ({ nameMatch, matchInfo, className }) => {
    return (
        <CenterInfoFight className={className}>
            <h6 className="info-fight-title fight-type">{nameMatch}</h6>
            <h6 className="info-fight-title fight-name">{matchInfo.type_match?.name}</h6>
            {matchInfo.belt && (
                <>
                    <BeltImg className="belt-img" src={process.env.REACT_APP_STORAGE_URL + matchInfo.belt.img_path} alt={matchInfo.belt.name} />
                    <h6>{matchInfo.belt.name}</h6>
                </>
            )}
            {matchInfo.is_no_contest ? (
                <span className="no-contest-title">NO CONTEST</span>
            ) : null}
            {matchInfo.notes ? (
                <span className="notes-title">{matchInfo.notes}</span>
            ) : null}
        </CenterInfoFight>
    );
};

interface AvatarWrestlerWhenThreeOrFourWrestlerInMatchProps {
    wrestler: WrestlerInMatch;
    win_by_dq?: boolean;
    navigateToWrestler: (wrestler: WrestlerInMatch) => void;
}

const AvatarWrestlerWhenThreeOrFourWrestlerInMatch: FC<AvatarWrestlerWhenThreeOrFourWrestlerInMatchProps> = ({ wrestler, win_by_dq, navigateToWrestler }) => {
    return (
        <AvatarOpponentBoxAvatar
            width="100px" height="100px"
            onClick={() => navigateToWrestler(wrestler)}
        >
            <img src={process.env.REACT_APP_STORAGE_URL + wrestler.avatar_path} alt={wrestler.name} />

            {wrestler.pivot.is_winner ? (
            <BoxWinnerGeneric className="small">
                <span className="winner-text">WIN</span>
                {win_by_dq ?
                    <span className="by-dq">BY DQ</span>
                : null}
            </BoxWinnerGeneric>
        ) : null}

        </AvatarOpponentBoxAvatar>
    );
};

export default CenterInfoFightComponentRender;
export { AvatarWrestlerWhenThreeOrFourWrestlerInMatch };
